import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  children: React.ReactNode;
  magnetic?: boolean;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  className,
  magnetic = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-full transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 hover:shadow-xl hover:-translate-y-1 active:translate-y-0 active:shadow-lg transform';
  const variantStyles = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 shadow-lg hover:shadow-blue-500/50',
    secondary: 'bg-gray-900 text-white hover:bg-gray-800 shadow-lg hover:shadow-gray-500/50',
    outline: 'border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white bg-white shadow-md hover:shadow-lg'
  };
  const sizeStyles = {
    sm: 'text-sm px-6 py-2.5',
    md: 'text-base px-8 py-3.5',
    lg: 'text-lg px-10 py-4'
  };
  const widthStyles = fullWidth ? 'w-full' : '';
  const combinedStyles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyles} ${className || ''}`;
  return <button className={combinedStyles} {...props} data-id="element-524">
      {children}
    </button>;
}